import clsx from 'clsx';
import React, { ReactNode } from 'react';
import styles from './styles.module.css';

interface MarkdownTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  terms?: boolean;
  blog?: boolean;
  children?: ReactNode | ReactNode[];
}

export const MarkdownText = ({ ...props }) => {
  const { terms, blog } = props;

  const headingClassName = clsx(styles.text, {
    [styles.terms]: terms,
    [styles.blog]: blog,
  });

  return React.createElement(`span`, {
    className: headingClassName,
    ...props,
  });
};

export const MarkdownP: React.FC<MarkdownTextProps> = ({
  children,
  terms,
  blog,
  ...props
}) => {
  const headingClassName = clsx(styles.text, {
    [styles.terms]: terms,
    [styles.blog]: blog,
  });

  const processedChildren = React.Children.map(children, (child, index) => {
    if (typeof child === 'string') {
      // Split on '\r' so that each segment can be separated by a <br /> element
      const lines = child.split('\r');
      return lines.reduce<React.ReactNode[]>((acc, line, i) => {
        if (line === 'HardSpace_HardSpace') {
          line = '';
          acc.push(<br key={`br-${index}-${i}`} />);
        }
        if (i > 0) {
          // Add a <br /> before each new line segment
          acc.push(<br key={`br-${index}-${i}`} />);
        }
        acc.push(line);
        return acc;
      }, []);
    }

    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        key: index,
        ...(child.props as Record<string, unknown>),
      });
    }

    return child;
  });

  return (
    <span className={headingClassName} {...props}>
      {processedChildren}
    </span>
  );
};
